/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserProfileDataResponse } from '../../models/user-profile-data-response';

export interface GetProfileData$Params {
}

export function getProfileData(http: HttpClient, rootUrl: string, params?: GetProfileData$Params, context?: HttpContext): Observable<StrictHttpResponse<UserProfileDataResponse>> {
  const rb = new RequestBuilder(rootUrl, getProfileData.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserProfileDataResponse>;
    })
  );
}

getProfileData.PATH = '/api/user/profile-data';
